<template>
	<div class="page" v-if="page">
		<section class="section">
			<div class="container content is-fullhd">
				<div class="columns is-multiline">
					<div class="column is-half" v-for="team in page.teams">
						<div class="box content">
							<h3><TeamLink :teamKey="team.key" :teamName="team.name" /></h3>

							<table class="table is-fullwidth">
								<thead>
									<tr>
										<th></th>
										<th>Player</th>
										<th class="has-text-right">Drafted As</th>
										<th class="has-text-right">Actual</th>
										<th class="has-text-right">Diff</th>
									</tr>
								</thead>
								<tbody>
									<template v-for="item in team.picks">
										<tr>
											<td class="has-text-right">{{ item.round }}.</td>
											<td>{{ item.player.name_full }}</td>
											<td class="has-text-right">{{ item.player.display_position }}-{{ item.position }}</td>
											<td class="has-text-right">
												{{ item.player.display_position }}-{{ item.player.position_rank }}
											</td>
											<td class="has-text-right">{{ item.player.draft_position_diff }}</td>
										</tr>
									</template>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import TeamLink from "@/components/TeamLink"

export default {
	components: {
		TeamLink,
	},
	computed: {
		league() {
			return this.$store.getters.activeLeague
		},
		page() {
			return this.$store.getters.activePage
		},
	},
	mounted() {
		this.$store.dispatch("setActivePage", "draft_teams")
	},
}
</script>

<style></style>
